import { dataMember, required, typedArray } from 'santee-dcts';
import { siteDisplayNameRenderer } from '../../renderer/site-display-name-renderer';

export class SponsorStudySiteIdentity {
    @dataMember()
    @required()
    public siteId: number;

    @required({ nullable: true })
    @dataMember()
    public investigatorFullName: string;

    @required()
    @dataMember()
    public siteNumber: string;

    @required()
    @dataMember()
    public isExtremelyLarge: boolean;

    @dataMember()
    public isAgeProject: boolean;

    public get siteDisplayName(): string {
        return siteDisplayNameRenderer({
            siteNumber: this.siteNumber,
            investigatorFullName: this.investigatorFullName
        });
    }

    public toString(): string {
        return this.siteDisplayName;
    }
}

export class SponsorStudySiteIdentitiesReadModel {
    @dataMember()
    @required()
    @typedArray(SponsorStudySiteIdentity)
    public siteIdentities: SponsorStudySiteIdentity[];
}
